import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from "../../components/Footer.js";
import HeaderTransprent from "../../components/HeaderTransprent.js";
import Heading from "../../components/ui/Heading.js";
import Button from "../../components/ui/Button.js";
// import ButtonBorder from "../../components/ui/ButtonBorder.js";
import Faq from "../../components/ui/Faq.js";
import ContactForm from "../../components/ui/ContactForm.js";
import JsonData from "../Json/leadership.json";
import { GoArrowUpRight } from "react-icons/go";

const Home = () => {

  const formRef = useRef(null);
  const history = useHistory();
  const [activeTab, setActiveTab] = useState("Corporate Law");

  const handleClick = (field) => {
    history.push(field ? `/${field}` : "/");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleScrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };


  return (
    <>
      <div className="overflow-hidden">

        <section className="bg-cover bg-no-repeat bg-right w-full h-auto bgpagecolor" style={{ backgroundImage: `url('/assets/home/index-hero-section.webp')`, }}>
          <HeaderTransprent />
          <div className="w-full h-full">
            <div className="flex md:flex-row flex-col gap-10 mx-auto px-4 xl:px-0 md:py-20 w-full 2xl:w-9/12 xl:w-11/12 md:h-[50rem] h-[35rem]">
              <div className="flex flex-col justify-center space-y-8 mx-auto my-auto pt-10 md:pt-0 md:pb-12 w-full h-full md:text-left text-center">
                <h1 data-aos="fade-right" className="font-bold text-5xl xl:text-6xl text-white">Expert Legal Help,<br /> When You Need It <br /> Most.</h1>
                <div data-aos="fade-right" className="font-medium text-base md:text-lg text-white">
                  <p className="pb-2">Trusted by individuals and businesses for sound legal advice, strategic representation, and results that matter.</p>
                </div>
                <div className="flex justify-center md:justify-start items-center md:items-center gap-4 md:w-80 w-full">
                  <Button text="Schedule a Free Consultation" onClick={handleScrollToForm} />
                </div>
              </div>

              <div className="flex justify-center items-center w-full">
                {/* <img data-aos="fade-left" src="/assets/home/agrpartners.webp" alt="agrpartners" className="z-0" /> */}
              </div>
            </div>
            <div className="bg-[#003366] text-white py-10">
              <div className="gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-9/12 xl:w-11/12">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-y sm:divide-y-0 sm:divide-x divide-[#FFFFFF]/30">
                  {/* Item 1 */}
                  <div className="flex items-start space-x-4 p-6">
                    <img src="/assets/svg-img/expert-lawyers.svg" alt="expert-lawyers" className="w-16 h-16" />
                    <div>
                      <h1 className="text-lg font-semibold">Expert Lawyers</h1>
                      <p className="text-sm mt-1 text-white/80">
                        Strategic counsel for entrepreneurs, startups, and enterprises.
                      </p>
                    </div>
                  </div>

                  {/* Item 2 */}
                  <div className="flex items-start space-x-4 p-6">
                    <img src="/assets/svg-img/transparent-and-trustworthy.svg" alt="transparent-and-trustworthy" className="w-16 h-16" />
                    <div>
                      <h1 className="text-lg font-semibold">Transparent & Trustworthy</h1>
                      <p className="text-sm mt-1 text-white/80">
                        Strategic counsel for entrepreneurs, startups, and enterprises.
                      </p>
                    </div>
                  </div>

                  {/* Item 3 */}
                  <div className="flex items-start space-x-4 p-6">
                    <img src="/assets/svg-img/fight-for-justice.svg" alt="fight-for-justice" className="w-16 h-16" />
                    <div>
                      <h1 className="text-lg font-semibold">Fight for Justice</h1>
                      <p className="text-sm mt-1 text-white/80">
                        Strategic counsel for entrepreneurs, startups, and enterprises.
                      </p>
                    </div>
                  </div>

                  {/* Item 4 */}
                  <div className="flex items-start space-x-4 p-6">
                    <img src="/assets/svg-img/affordable-fees.svg" alt="affordable-fees" className="w-16 h-16" />
                    <div>
                      <h1 className="text-lg font-semibold">Affordable Fees</h1>
                      <p className="text-sm mt-1 text-white/80">
                        Strategic counsel for entrepreneurs, startups, and enterprises.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section className="bg-white md:py-16 py-8">
          <div className="flex lg:flex-row flex-col-reverse items-center gap-10 mx-auto px-4 xl:px-0 py-10 w-full 2xl:w-9/12 xl:w-11/12">
            <div className="items-start gap-8 grid lg:grid-cols-2 mx-auto">
              <div class="md:pr-10 pr-0">
                <img src="/assets/home/why-choose-us.webp" alt="why-choose-us" class="" />
              </div>

              <div className="">
                <Heading text="Why Choose Us" text2="Committed to Justice. Driven by Integrity." paratext="At AGRPartners, we are a full-service law firm committed to delivering strategic, results-oriented legal solutions. Backed by a legacy of trust and a team of seasoned attorneys, we proudly serve individuals, families, and businesses across India." />

                <div class="gap-5 md:gap-8 grid grid-cols-1 sm:grid-cols-2 mt-8">
                  <div class="flex items-start space-x-4">
                    <img src="/assets/svg-img/expert-lawyers.svg" alt="expert-lawyers" className="w-12 h-12" />
                    <div>
                      <h1 class="text-lg font-semibold text-gray-800">Expert Lawyers</h1>
                      <p class="text-gray-600 text-base pt-3">Strategic counsel for entrepreneurs, startups, and enterprises.</p>
                    </div>
                  </div>
                  <div class="flex items-start space-x-4">
                    <img src="/assets/svg-img/transparent-and-trustworthy.svg" alt="transparent-and-trustworthy" className="w-12 h-12" />
                    <div>
                      <h1 class="text-lg font-semibold text-gray-800">Transparent & Trustworthy</h1>
                      <p class="text-gray-600 text-base pt-3">Strategic counsel for entrepreneurs, startups, and enterprises.</p>
                    </div>
                  </div>
                  <div class="flex items-start space-x-4">
                    <img src="/assets/svg-img/fight-for-justice.svg" alt="fight-for-justice" className="w-12 h-12" />
                    <div>
                      <h1 class="text-lg font-semibold text-gray-800">Fight for Justice</h1>
                      <p class="text-gray-600 text-base pt-3">Strategic counsel for entrepreneurs, startups, and enterprises.</p>
                    </div>
                  </div>
                  <div class="flex items-start space-x-4">
                    <img src="/assets/svg-img/affordable-fees.svg" alt="affordable-fees" className="w-12 h-12" />
                    <div>
                      <h1 class="text-lg font-semibold text-gray-800">Affordable Fees</h1>
                      <p class="text-gray-600 text-base pt-3">Strategic counsel for entrepreneurs, startups, and enterprises.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <section className="bgpagecolor md:py-16 py-8">
          <div className="text-center gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-9/12 xl:w-11/12">
            <Heading text="Practice Areas" paratext="Legal services tailored to your unique needs." />
            <div className="inline-flex rounded-md my-10 space-x-2 md:space-x-4">
              {Object.keys(JsonData.practiceAreas).map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`flex items-center justify-center text-center rounded-md cursor-pointer transition-all duration-150 py-5 md:px-10 px-3 md:text-lg text-base font-semibold bg-gradient-to-b whitespace-nowrap ${activeTab === tab
                    ? "from-[#CB9B2D]/50 to-transparent textblack"
                    : "from-[#212121]/10 to-transparent textblack"
                    }`}
                >
                  <span className="text-center">{tab}</span>
                </button>
              ))}
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-6 mb-10">
              {JsonData.practiceAreas[activeTab].slice(0, 6).map((area, index) => (
                <>
                  <div key={index} className="group bg-white md:p-8 p-6 rounded-lg shadow hover:shadow-md hover:bg-[#003366] text-left relative transition-all duration-300">
                    <div className="flex flex-col space-y-3 mb-16">
                      <div className="w-28 h-28 mx-auto flex flex-col items-center justify-center p-3 rounded-full bg-[#F7F8FA] transition-colors duration-300">
                        <img src={area.img} alt="leadership-report" className="w-20 h-20" />
                      </div>
                      <h1 className="pt-3 text-lg md:text-xl font-semibold text-black text-center group-hover:text-white transition-colors duration-300">{area.title}</h1>
                      <p className="text-black text-base py-3 group-hover:text-white transition-colors duration-300">{area.description}</p>
                      <ul className="list-disc space-y-2 text-gray-700 group-hover:text-white pl-5 text-left transition-colors duration-300">
                        {area.points.map((areas, idx) => (
                          <li key={idx}>{areas}</li>
                        ))}
                      </ul>
                    </div>
                    {/* Button Section */}
                    <div className="absolute flex justify-center items-center mx-auto gap-4 w-80 bottom-0 left-0 right-0 pb-5">
                      <button onClick={() => handleClick("practiceareas")} className="flex items-center justify-center space-x-3 px-6 py-3 rounded-md text-[#1A1F36] text-base cursor-pointer w-full border border-[#1A1F36] group-hover:text-white group-hover:bg-[#CB9B2D]">
                        <h1>Learn More</h1>
                        <GoArrowUpRight className="w-5 h-5 text-[#1A1F36] group-hover:text-white" />
                      </button>
                    </div>
                  </div>
                </>
              ))}
            </div>

            <div className="flex justify-center items-center mx-auto gap-4 w-64">
              <Button text="View All Services" onClick={() => handleClick("practiceareas")} />
            </div>
          </div>
        </section>

        <section className="bg-[#003366] md:py-16 py-8">
          <div className="text-center gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-9/12 xl:w-11/12">
            <h1 className="font-bold text-5xl xl:text-6xl text-white">Sectors We Serve</h1>
            <p className="text-white mt-4 mb-10">
              Industry-specific legal expertise that delivers.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-10">
              {JsonData.sectors.slice(0, 8).map((sector, idx) => (
                <div key={idx} className="bg-white overflow-hidden shadow-sm hover:shadow-md transition">
                  <img src={sector.image} alt={sector.name} className="h-44 w-full object-cover" />
                  <div className="p-4">
                    <h1 className="text-lg md:text-xl font-semibold text-gray-800">{sector.title}</h1>
                  </div>
                </div>
              ))}
            </div>


            <div className="flex justify-center items-center mx-auto gap-4 w-64">
              <button onClick={() => handleClick("practiceareas")} className="flex items-center justify-center space-x-3 px-6 py-3 rounded-md text-white text-base cursor-pointer bgcolor w-full">
                <h1>Learn More</h1>
                <GoArrowUpRight className="w-5 h-5 text-white" />
              </button>
            </div>
          </div>
        </section>

        {/* <section className="bg-[#fdf7ed] md:py-16 py-8">
          <div className="text-center gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-9/12 xl:w-11/12">
            <h1 className="font-bold text-5xl xl:text-6xl textblack mb-4">Meet Our Experts</h1>
            <p className="textblack mb-10">
              Trusted by individuals and businesses for sound legal advice, strategic.
            </p>
            <div className="flex justify-center">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-10">
                {JsonData.Expertise.map((lawyer, index) => (
                  <div key={index} className="rounded-lg overflow-hidden hover:shadow-md">
                    <div className="flex items-center justify-center">
                      <img src={lawyer.image} alt={lawyer.name} className="md:h-80 h-full object-contain" />
                    </div>
                    <div className="p-4">
                      <h1 className="text-xl md:text-2xl font-semibold textblack">{lawyer.name}</h1>
                      <p className="text-sm textblack pb-5 pt-1">{lawyer.title}</p>
                      <div className="flex justify-center items-center w-full">
                        <Button text="View Profile" onClick={() => history.push(lawyer.url)} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section> */}

        {/* <section className="bg-[#FFFFFF] py-16">
          <div className="text-center gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-9/12 xl:w-11/12">
            <h2 className="text-4xl font-semibold text-gray-900 mb-2">Legal Insights</h2>
            <p className="text-gray-600 mb-10">Trusted by individuals and businesses for sound legal advice, strategic.</p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
              {JsonData.legalInsights.map((lawyer, index) => (
                <div key={index} className="bg-white rounded-lg overflow-hidden shadow-sm">
                  <div className="flex items-center justify-center">
                    <img src={lawyer.image} alt={lawyer.name} className="h-full object-contain" />
                  </div>
                  <div className="p-4 text-start">
                    <h4 className="text-lg font-semibold textblack py-4">{lawyer.title}</h4>
                    <p className="text-sm textblack mb-4 line-clamp-2">{lawyer.datetime}</p>
                    <div className="flex items-center space-x-3 hover:text-[#CB9B2D] rounded-md text-[#003366] text-base cursor-pointer" >
                      <span>Read More</span>
                      <GoArrowRight className="w-5 h-5 text-[#003366]" />
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button className="bg-[#deb059] hover:bg-[#cfa248] text-white px-6 py-3 rounded-md text-sm font-medium inline-flex items-center gap-2 transition">
              View All <GoArrowRight className="w-5 h-5 text-[#FFFFFF]" />
            </button>
          </div>
        </section> */}


        <Faq />

        {/* <section className="py-8 bg-[#212121]">
          <div className="flex flex-col items-center justify-between w-full gap-10 px-4 py-10 mx-auto 2xl:w-9/12 xl:w-11/12 xl:px-0 lg:flex-row ">
            <div className="flex flex-col justify-center md:text-left text-center">
              <h1 className="text-3xl font-medium leading-tight title-font text-white">Explore Legal Support That Works for You</h1>
              <p className="text-3xl font-medium leading-tight title-font text-white"></p>
            </div>
            <div className="flex flex-col items-center justify-center flex-shrink-0 space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4 lg:ml-4 lg:justify-end">
              <Button text="Book a Demo" onClick={handleScrollToForm} />
            </div>
          </div>
        </section> */}

        {/* <Testimonial2 /> */}

        <section ref={formRef} className="bg-cover bg-no-repeat md:py-16 py-8 bg-[#F7F8FA]">
          <div className="flex flex-col justify-start w-full h-full 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div className="mx-auto px-4 w-full">
              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-1/2 flex flex-col justify-center md:mb-0 pr-0 md:pr-10 md:pt-0 pt-4">
                  <div className="flex items-center justify-center w-full">
                    <img src="/assets/home/contact-us.webp" alt="Lead with Clarity" className="z-0" />
                  </div>
                </div>
                <ContactForm />
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};


export default Home;
